'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMotion = require('react-motion');

var _withSlideContext = require('./with-slide-context');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Slide = function (_Component) {
    (0, _inherits3.default)(Slide, _Component);

    function Slide() {
        (0, _classCallCheck3.default)(this, Slide);
        return (0, _possibleConstructorReturn3.default)(this, (Slide.__proto__ || (0, _getPrototypeOf2.default)(Slide)).apply(this, arguments));
    }

    (0, _createClass3.default)(Slide, [{
        key: 'getScale',
        value: function getScale() {
            return this.isActive() ? 1 : 0.9 + 0.1 * this.props.progress;
        }
    }, {
        key: 'getBrightness',
        value: function getBrightness() {
            return this.isActive() ? 1 : 0.3 + 0.7 * this.props.progress;
        }
    }, {
        key: 'getTranslateX',
        value: function getTranslateX() {
            var direction = this.props.slideIndex < this.props.currentSlide ? 1 : -1;
            return this.isActive() ? 0 : 20 * direction * (1 - this.props.progress);
        }
    }, {
        key: 'getDesiredStyles',
        value: function getDesiredStyles() {
            return {
                brightness: this.getBrightness(),
                scale: this.getScale(),
                translateX: this.getTranslateX()
            };
        }
    }, {
        key: 'getSlideContext',
        value: function getSlideContext() {
            return {
                isActive: this.isActive(),
                slideIndex: this.props.slideIndex,
                activeSlideIndex: this.props.currentSlide,
                totalSlides: this.props.totalSlides
            };
        }
    }, {
        key: 'isActive',
        value: function isActive() {
            var _props = this.props,
                slideIndex = _props.slideIndex,
                currentSlide = _props.currentSlide,
                totalSlides = _props.totalSlides,
                isVirtual = _props.isVirtual;

            if (isVirtual) {
                return slideIndex === 0 && currentSlide === totalSlides || slideIndex === totalSlides + 1 && currentSlide === 1;
            }

            return slideIndex === currentSlide;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var theme = this.props.theme;


            var styles = this.getDesiredStyles();
            var slideContext = this.getSlideContext();
            return _react2.default.createElement(
                _withSlideContext.SlideContextBroadcast,
                { slide: slideContext },
                _react2.default.createElement(
                    _reactMotion.Motion,
                    {
                        style: {
                            brightness: (0, _reactMotion.spring)(styles.brightness),
                            scale: (0, _reactMotion.spring)(styles.scale),
                            translateX: (0, _reactMotion.spring)(styles.translateX)
                        }
                    },
                    function (_ref) {
                        var brightness = _ref.brightness,
                            scale = _ref.scale,
                            translateX = _ref.translateX;
                        return _react2.default.createElement(
                            'li',
                            {
                                className: theme.slide,
                                style: {
                                    zIndex: slideContext.isActive ? 1 : undefined,
                                    transform: 'scale(' + scale + ') translate3d(' + translateX + '%, 0, 0)',
                                    filter: 'brightness(' + brightness + ')'
                                }
                            },
                            _react2.default.createElement(
                                'div',
                                { className: theme.slideItemWrapper },
                                _this2.props.children
                            )
                        );
                    }
                )
            );
        }
    }]);
    return Slide;
}(_react.Component);

Slide.propTypes = {
    isVirtual: _propTypes2.default.bool.isRequired,
    children: _propTypes2.default.node.isRequired,
    currentSlide: _propTypes2.default.number.isRequired,
    totalSlides: _propTypes2.default.number.isRequired,
    slideIndex: _propTypes2.default.number.isRequired,
    progress: _propTypes2.default.number.isRequired,
    theme: _propTypes2.default.shape({
        slide: _propTypes2.default.string,
        slideItemWrapper: _propTypes2.default.string
    }).isRequired
};
exports.default = Slide;
//# sourceMappingURL=Slide.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-carousel/lib/cjs/Slide.js
 ** module id = 586
 ** module chunks = 1
 **/